const root = 'login-logInForm'

export const TestId = {
  emailInput: `${root}-emailInput`,
  passwordInput: `${root}-passwordInput`,
  submitButton: `${root}-SubmitButton`,
  resetPasswordLink: `${root}-resetPasswordLink`,
  legalNotice: `${root}-legalNotice`,
}
